/* eslint-disable prettier/prettier */
import React, { useRef, useState } from 'react';
import { View, ScrollView } from 'react-native';
import i18n from 'i18n-js';
import LinearGradient from 'react-native-linear-gradient';
import { connect } from 'react-redux';

import { firstLetterUp, timeLine, timePeriod } from '@helpers';
import { scale as initialScale } from '@components/frame';

import ColorWrapper from '@styles/colors';
import Selector from '@styles/selectors';
import { FeatureFlagsAvailable } from '@components/featureFlags';

const TimeLine = ({
  scale = initialScale,
  ignoreNow,
  font,
  featureFlags,
  activeTimeLine,
  setActiveTimeLine,
  blur = false,
  C,
  colors: { light, dark },
}) => {
  const scrollView = useRef(null);
  const [x, setX] = useState(0);

  const refsElements = {};

  const base = C.scheme === 'light' ? `${light},` : `${dark},`;

  const filteredTimes = timeLine.filter((item) => {
    refsElements[item.value] = useRef(null);

    if (item.value === timePeriod.NOW && ignoreNow) {
      return false;
    }

    if (FeatureFlagsAvailable(item.flag, featureFlags)) {
      return true;
    }
    return false;
  });

  return (
    <View style={{ position: 'relative', justifyContent: 'center' }}>
      {blur && (
        <LinearGradient
          colors={[`rgba(${base} 0)`, `rgba(${base} 0.9)`, `rgba(${base} 1)`]}
          locations={[0, 0.87, 1]}
          style={{
            position: 'absolute',
            width: scale(7),
            left: 0,
            zIndex: 100,
            height: scale(33),
          }}
          start={{ x: 1, y: 0 }}
          end={{ x: 0, y: 0 }}
        />
      )}
      {blur && (
        <LinearGradient
          colors={[`rgba(${base} 0)`, `rgba(${base} 0.9)`, `rgba(${base} 1)`]}
          locations={[0, 0.87, 1]}
          style={{
            position: 'absolute',
            width: scale(7),
            right: 0,
            zIndex: 100,
            height: scale(33),
          }}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        />
      )}
      <ScrollView
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        scrollEnabled={blur}
        ref={scrollView}
        onContentSizeChange={() => scrollView?.current?.scrollToEnd({ animated: false })}
        contentContainerStyle={{
          justifyContent: 'center',
          minWidth: '100%',
          paddingHorizontal: scale(20),
        }}
        scrollEventThrottle={16}
        onScroll={(e) => {
          setX(e.nativeEvent.contentOffset.x);
        }}
      >
        {filteredTimes.map((item) => (
          <View ref={refsElements[item.value]} key={item.value}>
            <Selector
              {...{
                scale,
                font,
                selected: activeTimeLine === item.value,
                variant: 'L',
                text: firstLetterUp(i18n.t(item.value)),
                onPress: () => {
                  setActiveTimeLine(item.value);
                  refsElements[item.value]?.current?.measure((fx, fy, width, height, px, py) => {
                    if (px < scale(30)) {
                      scrollView?.current?.scrollTo({ animated: true, x: x - (Math.abs(px) + scale(30)) });
                      return;
                    }
                    scrollView?.current?.measure((fx, fy, scrollWidth) => {
                      if (px + width + scale(30) > scrollWidth) {
                        const offset = px + width - scrollWidth + x;
                        scrollView?.current?.scrollTo({ animated: true, x: offset + scale(30) });
                      }
                    });
                  });
                },
              }}
            />
          </View>
        ))}
      </ScrollView>
    </View>
  );
};

export default connect(({ user: { featureFlags } }) => ({ featureFlags }), {})(ColorWrapper(TimeLine));
